<section class="packages-section">
  <div class="container">
    <p class="section-label text-center">No hard member-count cliffs.</p>

    <div class="pricing-container" @cascadeFadeIn>
      <mat-card *ngFor="let plan of pricingPlans" class="pricing-card" [ngClass]="{ 'highlight': plan.highlighted }">
        <div class="card-content">
          <mat-card-header class="card-header">
            <mat-card-title>
              <p class="plan-title">{{ plan.title }}</p>
              <h2 class="price">{{ plan.price }}</h2>
              <p class="price-note" [style.color]="plan.highlighted ? '#ffffff' : null">{{ plan.priceNote }}</p>
              <p *ngIf="plan.billingNote" class="billing-note">{{ plan.billingNote }}</p>
              <div *ngIf="plan.highlighted" class="tag">Most Popular</div>
            </mat-card-title>
          </mat-card-header>
          <p class="plan-description">{{ plan.description }}</p>
          <mat-divider></mat-divider>
          <mat-card-content>
            <ul>
              <li *ngFor="let feature of plan.features">{{ feature }}</li>
            </ul>
            <div *ngIf="plan.exclusiveHeading" class="exclusive-block">
              <p class="exclusive-eyebrow">{{ plan.exclusiveEyebrow }}</p>
              <p class="exclusive-heading">{{ plan.exclusiveHeading }}</p>
              <p class="exclusive-body">{{ plan.exclusiveBody }}</p>
            </div>
          </mat-card-content>

          <div class="spacer"></div>

          <mat-card-actions>
            <a mat-flat-button color="primary"
               [routerLink]="plan.buttonLink"
               [queryParams]="plan.queryParams"
               (click)="onPrimaryCta(plan)">
              {{ plan.buttonLabel }}
            </a>
            <a routerLink="/contact"
               [queryParams]="plan.secondaryQueryParams || { inquiryType: 'demo' }"
               class="secondary-link">
              {{ plan.secondaryLink }}
            </a>
          </mat-card-actions>
        </div>
      </mat-card>
    </div>

    <div class="pricing-footnotes">
      <p>
        Not ready for a paid plan yet?
        <a routerLink="/pricing" fragment="getting-started">See 90-Day Trial, Launch Program, and Concierge Migration</a>.
      </p>
      <p>
        Need custom apps, a larger Operator portfolio, or help moving from another system?
        <a routerLink="/contact" [queryParams]="{ inquiryType: 'pricing' }">Talk to us</a>
        about a custom arrangement.
      </p>
    </div>
  </div>
</section>
